import { gql } from '@apollo/client';

const EducationHistoryUniversitiesQuery = gql`
  query EducationHistoryUniversities($search: String) {
    universities(search: $search) {
      nodes {
        id
        name
      }
    }
  }
`;

export default EducationHistoryUniversitiesQuery;
